<app-generic-table
    [tableConfig]="tableConfig"
    [filtersConfig]="filtersConfig"
    (tableEvent)="getDispatchNotes($event)"
></app-generic-table>
